import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import { TypeMediaReleaseArticleFilterWithoutUnresolvableLinksResponse } from 'contentful-types'

import ArticleFilter, { FilterProps } from './ArticleFilter'
import { mapTags, ContentfulITag } from 'src/siteBuilder/renderer/contentful/mapTags'

const ContentfulPageFilter = withContentful<
  TypeMediaReleaseArticleFilterWithoutUnresolvableLinksResponse['fields'],
  FilterProps
>(ArticleFilter, {
  sysID: (props) => props.sys.id,
  filterTags: (props) => mapTags(props.fields.filterTags as unknown as ContentfulITag[]),
  baseTags: (props) => mapTags(props.fields.baseTags as unknown as ContentfulITag[]),
  customLoadMoreLabel: (props) => props.fields.customLoadMoreLabel,
})

export default ContentfulPageFilter
